import { inject, type InjectionKey, type Ref } from 'vue';

export const SearchHighlightTextInjectionKey = Symbol() as InjectionKey<Readonly<Ref<string | undefined>>>;

export const useSearchHighlightText = (): Readonly<Ref<string | undefined>> | undefined => {
  return inject(SearchHighlightTextInjectionKey, undefined);
};
